import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GifSettingsRatios',
  props: {
    aspectRatios: null,
    value: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: string): void;
}), expose: any, slots: any, attrs: any }) {





const onChange = (ratio: string) => {
  emits("input", ratio);
};

return { __sfc: true,emits, onChange }
}

})